import {
  collection,
  getDocs,
  orderBy,
  query,
  updateDoc,
  where,
  doc,
  getDoc,
  addDoc,
  deleteDoc,
} from "firebase/firestore";
import { db } from "../firebase";
import { CreateState, LoginPdfCreateState } from "../model/Systemparameters";
import { UserCardCreateState } from "../model/Systemparameters";
import { SystemParameter00000001 } from "../model/Systemparameters";

const systemParametersId = "00000001";

const systemParametersQuery = {
  // 団体に紐づく未完了の利用者作成ステート一覧取得
  getCreateState: async (tenantId: string): Promise<any | CreateState> => {
    console.log('systemParameters getCreateState access');
      const docsRef = await getDocs(
        query(
          collection(db, 'systemParameters/00000001/createState'),
          where('tenantId', '==', tenantId),
          where("status", "!=", "completion")
        )
      );
      return docsRef.docs.map((doc) => doc.data()).at(0) as CreateState;
  },
  // 利用者作成ステート登録
  addCreateState: async (createState: CreateState) => {
    try {
      const result  = await addDoc(
        collection(db, `systemParameters/00000001/createState`,createState.id),
        createState
      );
       await updateDoc(
        doc(db, result.path), {id: result.id}
       );
      return true;
    } catch (err: any) {
      console.error(err);
      return false;
    }
  },
  // 団体に紐づくログイン情報履歴一覧取得
  getLoginPdfCreateState: async (tenantId: string): Promise<any | LoginPdfCreateState> => {
    console.log('systemParameters getLoginPdfCreateState access');
      const docsRef = await getDocs(
        query(
          collection(db, 'systemParameters/00000001/loginPdfCreateState'),
          where('tenantId', '==', tenantId),
          where('status', '!=', 'standBy'),
          orderBy('createAt', 'desc')
        )
      );
      return docsRef.docs.map((doc) => doc.data());
  },
  // ログイン情報履歴登録
  addLoginPdfCreateState: async (LoginPdfCreateState: LoginPdfCreateState) => {
    console.log('systemParameters addCreatePDFInfo access');
    try {
      const result  = await addDoc(
        collection(db, `systemParameters/00000001/loginPdfCreateState`,LoginPdfCreateState.id),
        LoginPdfCreateState
      );
      await updateDoc(
        doc(db, result.path), {id: result.id}
      );
      return true;
    } catch (err: any) {
      console.error(err);
      return false;
    }
  },
  // ログイン情報履歴更新
  updateLoginPdfCreateState: async (LoginPdfCreateState: LoginPdfCreateState):
    Promise<void> => {
      console.log("systemParameters updateLoginPdfCreateState access");
      try {
        await updateDoc(
          doc(db, `systemParameters/00000001/loginPdfCreateState/${LoginPdfCreateState.id}`),
          LoginPdfCreateState);
      } catch (err: any) {
        console.error(err);
      }
  },
  // 団体に紐づく利用者IDカード発行申請書一覧取得
  getUserCardCreateState: async (tenantId: string): Promise<any | UserCardCreateState> => {
    console.log('systemParameters getUserCardCreateState access');
      const docsRef = await getDocs(
        query(
          collection(db, 'systemParameters/00000001/userCardCreateState'),
          where('tenantId', '==', tenantId),
        )
      );
      return docsRef.docs.map((doc) => doc.data());
  },
  // 利用者IDカード発行申請書添付
  addUserCardCreateState: async (userCardCreateState: UserCardCreateState) => {
    console.log("systemParameters addUserCardCreateState access");
    try {
      const result = await addDoc(
        collection(db, `systemParameters/00000001/userCardCreateState`),
        userCardCreateState
        );
      await updateDoc(
        doc(db, result.path), {id: result.id}
        );
        return true;
    } catch (err: any) {
      console.error(err);
      return false;
    }
  },
  // 利用者IDカード発行申請書削除
  deleteUserCardCreateState: async (id: string):
  Promise<void> => {
    console.log("systemParameters deleteUserCardCreateState access");
    try {
      await deleteDoc(doc(db, `systemParameters/00000001/userCardCreateState/${id}`));
    } catch (err: any) {
      console.error(err);
    }
 },
  // 申請ボタン押下時。申請日入力、ステータス変更("standBy")
  updateUserCardCreateState: async (userIdCardData: UserCardCreateState): Promise<void> => {
    console.log("systemParameters updateUserCardCreateState access");
    try {
      const applicationRef = doc(db, `systemParameters/00000001/userCardCreateState/${userIdCardData.id}`);
      await updateDoc(applicationRef,
        userIdCardData
      );
      } catch (err: any) {
      console.error(err);
    } 
 },
  // オプション契約の取得
  getOptionContract: async (): Promise<SystemParameter00000001 | any> => {
    console.log('systemParameters getOptionContract access');
    const docRef = await getDoc(doc(db, "systemParameters", systemParametersId));
    const config = docRef.data() as SystemParameter00000001;
    return config.optionContract;
  },

  // 各団体の利用者IDカード一覧の取得
  getUserIdCardCreatList: async (tenantId: string): Promise<UserCardCreateState[]> => {
    console.log('systemParameters getUserIdCardCreatList access');
    const docsRef = await getDocs(
      query(
        collection(db, `systemParameters/${systemParametersId}/userCardCreateState`),
        where('tenantId', '==', tenantId)
      )
    );
    return docsRef.docs.map((doc) => doc.data() as UserCardCreateState);
  },

  // 利用者IDカード申請枚数制限の有無を取得
  getUserIdCardRequestLimitFlg: async (): Promise<SystemParameter00000001 | any> => {
    console.log('systemParameters getUserIdCardRequestLimitFlg access');
    const docRef = await getDoc(doc(db, "systemParameters", systemParametersId));
    const config = docRef.data() as SystemParameter00000001;
    return config.userIdCardRequestLimitFlg;
  },

  // 利用者IDカード申請回数の制限数を取得
  getUserIdCardMaxRequestCount: async (): Promise<SystemParameter00000001 | any> => {
    console.log('systemParameters getUserIdCardMaxRequestCount access');
    const docRef = await getDoc(doc(db, "systemParameters", systemParametersId));
    const config = docRef.data() as SystemParameter00000001;
    return config.userIdCardMaxRequestCount;
  },

  // 利用者IDカード申請枚数の制限数を取得
  getUserIdCardMaxRequestSheet: async (): Promise<SystemParameter00000001 | any> => {
    console.log('systemParameters getUserIdCardMaxRequestSheet access');
    const docRef = await getDoc(doc(db, "systemParameters", systemParametersId));
    const config = docRef.data() as SystemParameter00000001;
    return config.userIdCardMaxRequestSheet;
  },
};

export default systemParametersQuery;